import CacheBase2 from '../../services/engines/CacheBase2';

const _name = 'StyleCache';

/**
 * StyleCache — stores style notes keyed by rk.
 * Extends CacheBase2 — get(rk), getAll(), addOrUpdate(), clear() inherited.
 */
class StyleCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Returns the style note matching the given title, or null.
     * @param {string} title - e.g. 'BodyEditorStyle - Dark'
     * @returns {object|null}
     */
    getByTitle = (title) => {
        const all = this.getAll();
        if (!all?.length) return null;
        return all.find((s) => s.title === title) ?? null;
    };
}

const styleCache = new StyleCache();
export default styleCache;
